"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeedsToReload = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("./Button");
var Wrapper_1 = require("./Wrapper");
var NeedsToReload = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, onReload = _a.onReload, _c = _a.displayError, displayError = _c === void 0 ? false : _c;
    return (react_1.default.createElement(Wrapper_1.Wrapper, { padding: '8px 16px', disabled: disabled, error: displayError },
        react_1.default.createElement(Button_1.ReloadButton, { disabled: disabled, onClick: onReload })));
};
exports.NeedsToReload = NeedsToReload;
